module.exports = __webpack_public_path__ + "media/assets/images/category/Sorry@2x-333ed951ac515e03711edbcaec004e0b.png";